module.exports = __webpack_public_path__ + "static/media/fat_tiger.5d3b4620.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/home/fat_tiger.png
 ** module id = 631
 ** module chunks = 0
 **/